import { createAction } from "redux-actions";
import { GET_DOCUMENTOS } from "../constants";
import { feathersFindDataAll } from "../services";

export const getDocumentos = createAction(GET_DOCUMENTOS, (user) => feathersFindDataAll('documentos',{ user })())